import {
  ChangeDetectorRef,
  Component,
  HostBinding,
  OnInit,
} from "@angular/core";
import { FormGroup } from "@angular/forms";
import { FieldConfig } from "../../field.interface";
import { SubmitService } from "./service/submit.service";
@Component({
  selector: "app-button",
  template: `
    <div class="row">
      <div class="col-12 demo-full-width margin-top" [formGroup]="group">
        <button
          type="submit"
          mat-raised-button
          color="primary"
          [disabled]="disabled()"
          [hidden]="hidden()"
        >
          {{ field.label }}
        </button>
      </div>
    </div>
  `,
  styles: [],
})
export class SubmitComponent implements OnInit {
  field: FieldConfig;
  group: FormGroup;

  @HostBinding("class") class = "";
  constructor(
    private submitservice: SubmitService,
    private cdr: ChangeDetectorRef
  ) {
    this.submitservice.submit.subscribe((value) => {
      if (value !== null && value !== undefined && this.field) {
        this.field.disabled = value;
        this.cdr.detectChanges();
      }
    });
  }
  ngOnInit() {
    this.class = this.field.claseGrillaBootstrap;
  }

  disabled() {
    return this.field.disabled === true;
  }

  hidden() {
    return !(this.field.visible != null ? this.field.visible : true);
  }
}
